export default "__VITE_ASSET__BI$xfTBW__"